import React from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

/**
 * The tanstack react query client singleton
 * @param children
 * @constructor
 */
export const ReactQueryClientProvider: React.FunctionComponent<
  React.PropsWithChildren
> = ({ children }) => {
  const [queryClient] = React.useState(() => getQueryClient());

  // sets up tanstack query plugin for chrome dev tools
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-underscore-dangle,react-compiler/react-compiler
    window.__TANSTACK_QUERY_CLIENT__ = queryClient;
  }

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

const getQueryClient: () => QueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      mutations: {
        // errors should be handled by the page flow
        throwOnError: false,
      },
      queries: {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        // errors should be handled by the page flow
        throwOnError: false,
      },
    },
  });
};
